import React, { useEffect, useState } from 'react';
import ContactUs from '../../components/ContactUs';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("contact");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          {seoData.metaTitle || "Contact | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Get in touch with Nutrillion for DNA based nutrition consultation"}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/contact"}
        />
      </Helmet>
      <ContactUs />
    </div>
  );
};

export default Contact;